import React from 'react';
import FormControl from '../../components/FormControl';
import { ErrorToastComponent as ErrorToast, SuccessToastComponent as SuccessToast } from '../../components/Toasts';
import { postData } from '../../helper';
import { store, fetch } from './common';

class PickupDetailsForm extends React.Component {
    constructor(props) {
        super();
        this.submitHandler = this.submitHandler.bind(this);
        const self = this;
        const siteData = fetch(props.site_id);
        this.state = {
            err_message: null,
            form: {
                onSubmit: self.submitHandler
            },
            fields: { 
                address_line1: {
                    label: 'Address Line 1',
                    type: 'text',
                    placeholder: 'Address Line 2',
                    value: siteData?.order_pickup_details?.address_line1,
                    required: true,
                    onChange: self.onChangeHandler
                },
                address_line2: {
                    label: 'Address Line 2',
                    type: 'text',
                    placeholder: 'Address Line 2',
                    value: siteData?.order_pickup_details?.address_line2,
                    required: true,
                    onChange: self.onChangeHandler
                },
                landmark: {
                    label: 'Landmark',
                    type: 'text',
                    placeholder: 'Landmark',
                    value: siteData?.order_pickup_details?.landmark,
                    required: true,
                    onChange: self.onChangeHandler
                },
                pincode: {
                    label: 'Pincode',
                    type: 'text',
                    placeholder: 'Pincode',
                    value: siteData?.order_pickup_details?.pincode,
                    required: true,
                    onChange: self.onChangeHandler
                },
                city: {
                    type: 'city',
                    placeholder: 'City',
                    value: siteData?.order_pickup_details?.city,
                    required: true,
                    onChange: self.onChangeHandler
                },
                state: {
                    type: 'state',
                    placeholder: 'State',
                    value: siteData?.order_pickup_details?.state,
                    required: true,
                    onChange: self.onChangeHandler
                },
                create_button: {
                    type: 'button',
                    label: 'Update',
                    btn_type: 'submit'
                }
            }
        };
    }

    onChangeHandler = (e) => {
        try {
            const fields = this.state.fields;
            fields[e.target.name].value = e.target.value;
            this.setState({fields: fields});
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async submitHandler(payload) {
        try {
            const siteID = this.props.site_id;
            const requestPayload = {
                order_pickup: payload
            }
            const response = await postData(`/sites/${siteID}/details`, requestPayload, 'PUT');
            if(response.error && response.error.message) {
                this.setState({err_message: response.error.message});
                return;

            } 
            this.setState({success_message: 'order pickup details updated'});
            store(siteID, response);

        } catch(err) {
            return new Error(err.message);
        }
    }

    render() {
        return (
            <>
                <div className="card o-hidden">
                    <div className="card-body p-0">
                        <div className="p-5">
                            <h3>Order Pickup Details</h3>
                            <FormControl fields={this.state.fields} config={this.state.form}/>
                            <ErrorToast message={this.state.err_message}/>
                            <SuccessToast message={this.state.success_message}/>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
    
export default PickupDetailsForm;